<template>
  <div>
    <v-card v-if="hasSubmissions" class="my-3">
      <v-toolbar color="secondary" dark>
        <v-toolbar-title>My evaluation monitor</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat v-on:click="getJobStatus">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card v-if="hasSubmissions" class="pl-3">
        <v-card-text color="info">
          <div>
            <h4>Status:</h4> 
            <p>{{ lastJob.job_state }}</p>

            <h4 v-if="lastJob.job_progress">Progress:</h4>
            <p>{{ lastJob.job_progress }}</p>

            <div v-if="lastJob.show_progress_bar">
              <v-progress-linear v-model="lastJob.job_percentage"></v-progress-linear>
            </div>

            <h4 class="mt-3" v-if="lastJob.job_started_dt">Started processing at:</h4> 
            <p>{{ lastJob.job_started_dt }}</p>
            <h4 v-if="lastJob.job_finished_dt">Finished processing at:</h4> 
            <p>{{ lastJob.job_finished_dt }}</p>
          </div>
        </v-card-text>
      </v-card>
    </v-card>

    <!-- Full list of submissions in expansion panel below -->
    <v-card v-if="hasSubmissions">
      <v-toolbar color="secondary" dark>
        <v-toolbar-title>My submissions</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat v-on:click="getSubmissions">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-expansion-panel>
        <v-expansion-panel-content v-for="(sub,i) in mySubmissions" :key="i">
          <!-- <div slot="header"><strong>{{ i+1 }}.</strong> <v-icon></v-icon>{{ sub.label }}</div> -->
          <!-- <div slot="header"><span class="text-xs-left">{{ sub.label }}</span><span class="text-xs-right">{{ sub.datetime_str }}</span></div> -->
          <div slot="header"><strong>{{ sub.label }}</strong> <em>(submitted {{ sub.datetime_str }})</em></div>
          <v-card class="pl-3" color="grey lighten-3">
            <!-- <v-card-text class="grey darken-2" dark>Status: {{ sub.status }}</v-card-text> -->
            <!-- <v-card-text class="ml-6" color="info">Status: {{ sub.status }}</v-card-text> -->
              <v-card-text color="info">
                <div>
                  <h4>Container:</h4>
                    <p>{{ sub.container_url }}</p>
                  <h4>Status:</h4>
                    <p>{{ sub.status }}</p>
                  <h4>Submitted at:</h4>
                    <p>{{ sub.datetime_str }}</p>                    
                  <!-- <h4>Total progress:</h4> -->
                    <!-- <p>{{ sub.progress }}</p> -->
                  <h4>Scores:</h4>
                    <p>{{ sub.metrics }}</p>
<!--                     <p>
                      mAP score (primary score): {{ sub.metrics.map }}<br>
                      mAP for small objects: {{ sub.metrics.map_small }}<br>
                      mAP for medium objects: {{ sub.metrics.map_medium }}<br>
                      mAP for large objects: {{ sub.metrics.map_large }}<br>
                      mAP for common objects: {{ sub.metrics.map_common }}<br>
                      mAP for rare objects: {{ sub.metrics.map_rare }}<br>
                      F1 score: {{ sub.metrics.f1 }}<br>
                    </p> -->
                </div>
              </v-card-text>
<!--             <v-card-text class="info">Evaluation progress: {{ sub.stage }} of N</v-card-text>
            <v-card-text class="info">Description: {{ sub.description }}</v-card-text>
            <v-card-text class="info">Error: {{ sub.error }}</v-card-text>
            <v-card-text class="info">Log: {{ sub.log }}</v-card-text> -->
          </v-card>
          <v-card v-if="sub.has_error" class="pl-3" color="orange lighten-3">
            <v-card-text>
              <h3>Error:</h3>
              <h4>Error message:</h4>
              <p>{{ sub.error_message }}</p>
              <h4></h4>
              <p>{{ sub.error_str }}</p>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card>

    <v-card v-else>
      <v-container>
        <h4>No submissions to display.</h4>
        <p class='mb-1'>If you are seeing this message after submitting one or more containers for evaluation, please check your internet connectivity.</p>
      </v-container>
    </v-card>

    <p class="mt-3" v-if="hasSubmissions">
      Looking for info on error codes and what they mean? Check out the <a href="/errors">Errors page</a>.
    </p>

<!--     <p class="my-3">
      <v-btn to='submit' color="primary" dark class="mx-0">Submit a solution?</v-btn>
    </p> -->

  </div>
</template>

<script>
  import axios from 'axios'
  import firebase from 'firebase'
  // import ProgressBar from 'vue-radial-progress'

  export default {
    // name: 'Submissions',
    data () {
      return {
        // username: '',
        // baseUrl: 'http://localhost:3000',
        // baseUrl: 'http://54.89.212.20:3000',
        // username: firebase.auth().currentUser.uid(true),
        // user_id_token: firebase.aut().currentUser.getIdToken(true)
        // jwtInput: '',
        // idToken: '',

        mySubmissions: [],
        lastJob: {}
        // mySubmissions: [
        //   {
        //     label: 'mock submission',
        //     datetime_str: '2018-03-12:13:50:11',
        //     container_url: 'https://473892.foo.bar:v1',
        //     status: 'ranked',
        //     progress: '',
        //     metrics: {
        //       'map': 0.001,
        //       'map_small': 0.002,
        //       'map_medium': 0.003,
        //       'map_large': 0.004,
        //       'map_common': 0.005,
        //       'map_rare': 0.006,
        //       'f1': 0.007
        //     }
        //   }
        // ]

        // zeroSubmissions: null
        // completedSteps: 0,
        // totalSteps: 6
      }
    },

    // components: {
    //   RadialProgressBar
    // },
    methods: {
      getToken: function () {
        firebase.auth().currentUser.getIdToken(true)
        .then((idToken) => {
          this.$set(this.$data, 'idToken', idToken)
        })
      },
      getSubmissions: function () {
        // console.log('Fetching submissions...')
        firebase.auth().currentUser.getIdToken(true)
        .then((idToken) => {
          var submissionsUrl = this.$store.getters.baseUrl.concat('/submissions')
          axios.get(submissionsUrl,
            { headers: { 'Authorization': 'Bearer ' + idToken } }
          )
          .then((response) => {
            this.$set(this.$data, 'mySubmissions', response.data)
          })
          .catch(e => {
            this.errors.push(e)
          })
        })
        .catch(err => {
          this.errors.push(err)
        })
      },
      getJobStatus: function () {
        // console.log('Fetching status of my last job...')
        firebase.auth().currentUser.getIdToken(true)
        .then((idToken) => {
          var statusUrl = this.$store.getters.baseUrl.concat('/last')
          axios.get(statusUrl,
            { headers: { 'Authorization': 'Bearer ' + idToken } }
          )
          .then((response) => {
            // console.log(response.data)
            this.$set(this.$data, 'lastJob', response.data)
          })
          .catch(e => {
            this.errors.push(e)
          })
        })
        .catch(err => {
          this.errors.push(err)
        })
      }
    },

    computed: {
      hasSubmissions: function () {
        if (this.mySubmissions.length > 0) {
          return true
        } else {
          return false
        }
      },
      baseUrl () {
        return this.$store.getters.baseUrl
      },
      reverseItems () {
        return this.items.slice().reverse()
      }
    },
    created () {
      this.getJobStatus()
      this.getSubmissions()
    },
    mounted () {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Challenge/Submissions.vue